import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { IconSettings } from '@salesforce/design-system-react';
import './styles.css';
import { Provider } from 'react-redux';
import App from './App';
import init from './init';
import store from './store';
import ThemeProvider from './context/ThemeContext';

init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router>
      <IconSettings iconPath="/assets/icons">
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </IconSettings>
    </Router>
  </Provider>
);
